var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"printblack",style:(_vm.highlight ? _vm.highlightStyle : _vm.normalStyle),attrs:{"cursor":"initial"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.answerer.nick_name)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }